export default {
  name: "List",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M26 3H6a2 2 0 0 0-2 2v22c0 1.1.9 2 2 2h20a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM6 27V5h20v22H6zm17-17a1 1 0 0 1-1 1h-8c-.55 0-1-.45-1-1s.45-1 1-1h8a1 1 0 0 1 1 1zm-12 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm12 6a1 1 0 0 1-1 1h-8c-.55 0-1-.45-1-1s.45-1 1-1h8a1 1 0 0 1 1 1zm-12 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm12 6a1 1 0 0 1-1 1h-8c-.55 0-1-.45-1-1s.45-1 1-1h8a1 1 0 0 1 1 1zm-12 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z",
  },
}
